import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/molarity-calculator',
  component: () => import('../../routes/MolarityCalculator.svelte'),
  card: {
    id: 'molarity-calculator',
    title: 'Molarity Calculator',
    description: 'Calculate solution molarity from mass, volume, and molecular weight. Also computes dilutions with C₁V₁ = C₂V₂.',
    icon: 'science',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/molarity-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Molarity Calculator – Solution Concentration & Dilution Calculator',
    description: 'Free molarity calculator. Calculate solution concentration (mol/L) from mass, molecular weight, and volume. Includes dilution calculator using C₁V₁ = C₂V₂.',
  },
};

export default meta;
